
type Props = {
  column: string;
  value: string;
  onClose: () => void;
};

export function FullValueModal({ column, value, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        className="max-h-[80vh] w-full max-w-2xl overflow-auto rounded-lg border border-slate-200 bg-white p-4 shadow-xl dark:border-border dark:bg-surface"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mb-2 flex items-center justify-between gap-3">
          <h3 className="min-w-0 truncate text-sm font-semibold text-slate-900 dark:text-slate-100">
            {column}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded px-2 py-1 text-slate-500 hover:bg-slate-100 dark:hover:bg-surface-2"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <pre className="whitespace-pre-wrap break-words text-[13px] text-slate-800 dark:text-slate-200">
          {value || "Blank"}
        </pre>
        <div className="mt-3 text-right">
          <button
            type="button"
            onClick={() => navigator.clipboard?.writeText(value)}
            className="rounded border border-slate-300 px-2 py-1 text-[12px] text-slate-700 hover:bg-slate-50 dark:border-border dark:text-slate-300 dark:hover:bg-surface-2"
          >
            Copy
          </button>
        </div>
      </div>
    </div>
  );
}
